import { render, staticRenderFns } from "./topshooters.vue?vue&type=template&id=86123f2c&scoped=true&"
import script from "./topshooters.vue?vue&type=script&lang=js&"
export * from "./topshooters.vue?vue&type=script&lang=js&"
import style0 from "./topshooters.vue?vue&type=style&index=0&id=86123f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86123f2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
